import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { readingTimeManagementData, getDataForDifficulty } from './data/skills/reading/readingTimeManagement';

export default function ReadingTimeManagement() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : readingTimeManagementData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
